export default "__VITE_ASSET__584596d3__"